/* Disabling max-len and prettier to make it easier
   to maintain sort order of constants.  No need to wrap
   longer ones on multiple lines making it harder to sort
   the lines.
 */
/* eslint-disable max-len,prettier/prettier */
export const PRODUCT_AREAS = {
  BENEFITS: 'benefits',
  ADMIN_BILLING_PAGE: 'admin_billing_page',
  APPLICATION_QUESTIONS: 'application_questions',
  BACKGROUND_CHECKS: 'background_checks',
  BILLING: 'billing',
  BILLING_PAGE: 'billing_page',
  BREAK_COMPLAINCE_SETTINGS: 'Break & Complaince settings',
  BREAK_ENFORCEMENT: 'Break enforcements',
  CLOVER_WEB_SIGN_UP: 'clover_web_sign_up',
  CLOVER_WEB_SIGN_UP_EMBEDDED: 'clover_web_sign_up_embedded',
  COMMAND_BAR: 'command_bar',
  COMPANY_TIMESHEETS: 'company_timesheets',
  DASHBOARD: 'dashboard',
  DOCUMENTS: 'documents',
  GHOST_PACKAGING: 'ghost_packaging',
  GLOBAL: 'global',
  HELP_CENTER: 'help_center',
  HELP_PAGE: 'help_page',
  HIRING: 'hiring',
  HIRING_ASSISTANT: 'hiring_assistant',
  TRAINING_ASSISTANT: 'training_assistant',
  HIRING_DASHBOARD: 'hiring_dashboard',
  HIRING_DASHBOARD_V_1: 'hiring_dashboard_v_1',
  HR_PRO: 'hr_pro',
  INTEGRATION: 'integration',
  JOB_POST_FLOW: 'job_post_flow',
  LAUNCH_WEEK: 'launch_week',
  MANAGE_APPLICANTS: 'manage_applicants',
  MESSAGING: 'messaging',
  MESSAGES: 'messages',
  MESSENGER: 'messenger',
  MONETIZATION: 'monetization',
  NAVIGATION: 'navigation',
  NEW_HIRE_ONBOARDING: 'new_hire_onboarding',
  NEW_HIRE_PACKET: 'new_hire_packet',
  ONBOARDING: 'onboarding',
  OVERLAY: 'overlay',
  PAYING_BASE: 'paying_base',
  PAYROLL: 'payroll',
  PAYROLL_DASHBOARD: 'payroll dashboard',
  PAYROLL_SELF_SERVE: 'payroll_self_serve',
  PAYWALL: 'paywall',
  POST_SIGNUP: 'post_signup',
  PTO: 'pto',
  QUICK_START_GUIDE: 'quick_start_guide',
  QUICK_START_GUIDE_V2: 'quick_start_guide_v2',
  REFERRALS: 'referrals',
  REPORTS: 'reports',
  REQUESTS: 'requests',
  ROLES: 'roles',
  SCHEDULE: 'schedule',
  SCHEDULE_BUILDER: 'schedule_builder',
  SETTINGS: 'settings',
  SHIFT_PAY_EMPLOYER_MARKETING: 'finserv_web_app',
  SIGNATURE_BLOCK: 'signature_block',
  SIGN_IN: 'sign_in',
  SIGN_UP: 'sign_up',
  TASK_MANAGER: 'task_manager',
  TEAM: 'team',
  TEAM_ANNOUNCEMENTS: 'team_announcements',
  TIERS_DOWNGRADE: 'tiers_downgrade',
  TIERS_PAGE: 'tiers_page',
  TIMESHEETS: 'timesheets',
  TIP_MANAGER: 'tip_manager',
  TIME_CLOCK_SETTINGS: 'time_clock_settings',
  TLWA_2025: 'tlwa_2025',
  USER_WEB_TIMECLOCK: 'user_web_timeclock',
  WEB_DASHBOARD: 'web_dashboard',
  WEB_DASHBOARD_V_3: 'web_dashboard_v_3',
};

export const EVENT_CATEGORIES = {
  ACKNOWLEDGED_WAIVED_BREAK: 'Manager acknowledged waived break',
  ADD_APPLICANTS_MANUALLY: 'add_applicants_manually',
  ADD_DEPARTMENT: 'add_department',
  ADD_TASK_LIST: 'add_task_list',
  ADD_SINGLE_TASK: 'add_single_task',
  ADD_NESTED_TASK: 'add_nested_task',
  ADD_SINGLE_PAYROLL_LOCATION_FLOW: 'add_single_payroll_location_flow',
  ADD_TEAM_DRAWER: 'add_team_drawer',
  ADD_TEAM_PAYROLL_FLOW: 'add_team_payroll_flow',
  ADD_TEAM_SUCCESS: 'add_team_success',
  ADMIN_BILLING_PAGE: 'admin_billing_page',
  ADDON_CANCELLATION_FORM: 'addon_cancellation_form',
  ANNOUNCEMENTS: 'announcements',
  AVAILABILITY_CARD: 'availability_card',
  APPLICANT_MESSAGES: 'applicant_messages',
  API_ACCESS: 'api_access',
  AUTO_ARCHIVE_MODAL: 'auto_archive_modal',
  RETIREMENT: 'retirement',
  HEALTH: 'health',
  BILLING_MODAL: 'billing_modal',
  BILLING_PAGE: 'billing_page',
  BLOCKED_PAYROLL_NSF: 'Blocked Payroll - NSF',
  BOOST_PURCHASE: 'boost_purchase',
  BREAK: 'Break',
  BULK_ACTIONS_DRAWER: 'bulk_actions_drawer',
  CALLBACK_CONFIRMATION_SCREEN: 'callback_confirmation_screen',
  CERTIFICATES: 'certificates',
  CHANNEL_LIST: 'channel_list',
  CHECKOUT: 'checkout',
  CLOCKED_IN: 'clocked_in',
  CLOCKED_IN_BREAK: 'clocked_in_break',
  CLOCKED_OUT: 'clocked_out',
  CLOCKED_OUT_BREAK: 'clocked_out_break',
  CLOSE_PAYROLL_RUN_CONFIRMATION: 'close_payroll_run_confirmation',
  CONTACT_INFO: 'contact_info',
  COMMAND_BAR: 'command_bar',
  CONVERSATION: 'conversation',
  CONVERSATION_LIST: 'conversation_list',
  CONVERSATION_INFO: 'conversation_info',
  CONVERSATION_MENU: 'conversation_menu',
  COVER_CARD: 'cover_card',
  COPY_WEEK_MODAL: 'copy_week_modal',
  CREATE_APPLICATION_QUESTIONS_PAGE: 'create_application_questions_page',
  DASHBOARD: 'dashboard',
  DASHBOARD_BANNER_1_PAYROLL_LOVE_QUIZ: 'dashboard_banner_1_payroll_love_quiz',
  DASHBOARD_BANNER_2_PAYROLL_LOVE_QUIZ_FOLLOW_UP_1:
    'dashboard_banner_2_payroll_love_quiz_follow_up_1',
  DASHBOARD_BANNER_3_NEW_CUSTOMER_3_MONTHS_FREE:
    'dashboard_banner_3_new_customer_3_months_free',
  DASHBOARD_BANNER_4_NEW_CUSTOMER_6_MONTHS_FREE:
    'dashboard_banner_4_new_customer_6_months_free',
  DASHBOARD_BANNER_5_ABANDON_CART_3_MONTHS_FREE:
    'dashboard_banner_5_abandon_cart_3_months_free',
  DASHBOARD_BANNER_6_ABANDON_CART_6_MONTHS_FREE:
    'dashboard_banner_6_abandon_cart_6_months_free',
  DASHBOARD_COMPANY: 'dashboard_company',
  DASHBOARD_GET_MOBILE_APP_CARD_MY_WEEK: 'get_mobile_app_card_week',
  DASHBOARD_MANAGER: 'dashboard_manager',
  DASHBOARD_MY_WEEK: 'dashboard_my_week',
  DASHBOARD_PAYROLL_HISTORY: 'dashboard_payroll_history',
  DASHBOARD_SETUP_PAYROLL_AD: 'dashboard_setup_payroll_ad',
  DASHBOARD_STANDARD_PAYROLL: 'dashboard_standard_payroll',
  DAILY_REVIEW: 'daily_review',
  DELETE_ROLE: 'delete_role',
  DEPARTMENTS: 'departments',
  DEPARTMENTS_ROLES: 'departments_roles',
  DOWNGRADE_MODAL: 'downgrade_modal',
  DOWNGRADE_SURVEY: 'downgrade_survey',
  DOWNGRADE_DRAWER: 'downgrade_drawer',
  ENFORCEMENT_DRAWER: 'enforcement_drawer',
  DOWNLOAD_COMPANY_TIMESHEETS: 'download_company_timesheets',
  DOWNLOAD_TIMESHEETS_MODAL: 'download_timesheets_modal',
  EDIT_APPLICATION_QUESTIONS_PAGE: 'edit_application_questions_page',
  EDIT_PAYROLL_RUN_MODAL: 'edit_payroll_run_modal',
  EDIT_SINGLE_TASK: 'edit_single_task',
  EDIT_TASK_LIST: 'edit_task_list',
  EDIT_NESTED_TASK: 'edit_nested_task',
  EDIT_AUTOPAYROLL_RUN_MODAL: 'edit_autopayroll_run_modal',
  EMPLOYEE_CHOICE: 'employee_choice',
  EMPTY_STATE: 'empty_state',
  EMPTY_STATE_PAGE: 'empty_state_page',
  EMPLOYEE_CAP: 'employee_cap',
  END_OF_INTEGRATION_MODAL: 'end_of_integration_modal',
  END_OF_TRIAL_VARIANT_1: 'end_of_trial_variant_1',
  ENFORCEMENT_CAPS_PAYWALLS_MODAL: 'employee_caps_paywalls_modal',
  EXPORT_COMPANY_TIMESHEETS: 'export_company_timesheets',
  FIRST_PAYROLL_RUN: 'first_payroll_run',
  FREE_BACKGROUND_CHECKS: 'free_background_checks',
  FORGOT_PASSWORD: 'forgot_password',
  FTUX_PANEL: 'ftux_panel',
  GEOFENCE_SETTING: 'geofence_setting',
  GET_A_TIME_CLOCK: 'get_a_time_clock',
  GET_HELP_BUTTON: 'get_help_button',
  GET_HELP_PANEL_CALLBACK_FORM: 'get_help_panel_callback_form',
  GET_MOBILE_APP_MODAL: 'get_mobile_app_modal',
  GHOST_PACKAGING_PAYWALL_MTC: 'ghost_pkg_paywall_mtc',
  GUSTO_PAYROLL: 'gusto_payroll',
  GROWTH_STRIDE_HEALTH_ER_FLOW: 'growth_stride_health_er_flow',
  HB_DASHBOARD_PAYROLL_RECOMMENDATION: 'hb_dashboard_payroll_recommendation',
  HELP_PAGE: 'help_page',
  HIRING_APPLICANTS: 'hiring_applicants',
  HIRING_CAREER_PAGE: 'hiring_career_page',
  HIRING_DASHBOARD: 'hiring_dashboard',
  HIRING_DASHBOARD_TRIAL_BANNER: 'dashboard_trial_banner',
  HIRING_DASHBOARD_TRIAL_END: 'dashboard_trial_end',
  HIRING_DASHBOARD_ALL_CANDIDATES: 'hiring_dashboard_all_candidates',
  HIRING_DASHBOARD_ALL_CANDIDATES_FOR_POST:
    'hiring_dashboard_all_candidates_for_post',
  HIRING_DASHBOARD_TOP_CANDIDATES: 'hiring_dashboard_top_candidates',
  HIRING_DASHBOARD_SCREENED_CANDIDATES: 'hiring_dashboard_screened_candidates',
  HIRING_DASHBOARD_TOP_CANDIDATES_FOR_POST:
    'hiring_dashboard_top_candidates_for_post',
  HIRING_DASHBOARD_SCREENED_CANDIDATES_FOR_POST:
    'hiring_dashboard_screened_candidates_for_post',
  HIRING_DASHBOARD_JOB_DETAIL_VIEW: 'hiring_dashboard_job_detail_view',
  HIRING_DASHBOARD_JOB_POSTS: 'hiring_dashboard_job_posts',
  HIRING_DECLINE_INTERVIEW: 'hiring_decline_interview',
  HIRING_INTERVIEWS: 'hiring_interviews',
  HIRING_FTU_HEADER: 'hiring_ftu_header',
  HIRING_JOBS: 'hiring_jobs',
  HIRING_JOB_BOARD: 'hiring_job_board',
  HIRING_JOB_POST: 'hiring_job_post',
  HIRING_JOB_POST_SUCCESS: 'hiring_job_post_success',
  HIRING_SCHEDULE_INTERVIEW_TOP_CANDIDATE:
    'hiring_schedule_interview_top_candidate',
  HIRING_SCREENER_PREVIEW: 'hiring_screener_preview',
  HIRING_RESCHEDULE_INTERVIEW: 'hiring_reschedule_interview',
  HIRING_ZERO_STATE_PAGE: 'hiring_zero_state_page',
  HIRING_BANNER_SWITCH: 'hiring_banner_switch',
  HIRING_SWITCH_PAGE: 'hiring_switch_page',
  HISTORY_TAB: 'history_tab',
  HOMEBASE_NATIVE_JOB: 'homebase_native_job',
  HOMEBASE_PAYROLL_MODAL: 'homebase_payroll_modal',
  HOURLY_LABOR_COSTS: 'hourly_labor_costs',
  I2S_WEB: 'i2s_web',
  INCEPTION_PAYROLL: 'inception_payroll',
  INCOMPLETE_ADDONS_CANCELLATION_FORM_DIALOG:
    'incomplete_addons_cancellation_form_dialog',
  INVITE_TEAMMATE_MODAL: 'invite_teammate_modal',
  INVOICED_COMPANIES: 'invoiced_companies',
  I_9_FORM: 'i_9_form',
  JOB_APPLICANTS: 'job_applicants',
  JOB_DESCRIPTION: 'job_description',
  JOB_DESCRIPTION_PAGE_WITH_ROLE_AND_LOCATION_SELECTOR:
    'job_description_page_with_role_and_location_selector',
  JUMPSTART_PAST_WEEK_DRAWER: 'jumpstart_past_week_drawer',
  JUMPSTART_PAST_WEEK_DRAWER_COPY: 'jumpstart_past_week_drawer_copy',
  JUMPSTART_TEMPLATE_DRAWER: 'jumpstart_template_drawer',
  LABOR_COST_SUMMARY: 'labor_cost_summary',
  LABOR_BY_TYPE: 'labor_by_type',
  LANDING_PAGE: 'landing_page',
  LATE_PAYROLL_RUN: 'late_payroll_run',
  LAUNCH_WEEK: 'launch_week',
  LAUNCH_WEEK_STORY: 'launch_week_story',
  LAUNCH_WEEK_SHARE: 'launch_week_share',
  LEFT_NAVIGATION: 'left_navigation',
  LIGHTSPEED: 'lightspeed',
  LIVE_SCREENER: 'live_screener',
  LOCATION: 'location',
  MANAGE_PLAN_PAGE: 'manage_plan_page',
  MANAGE_PLANS_FOCUS_VIEW_PAGE: 'manage_plans_focus_view_page',
  MANAGE_TAB: 'manage_tab',
  MANAGER_ACCESS_PAYWALL: 'manager_access_paywall',
  MANAGER_LOG: 'manager_log', // TODO: This should be in PRODUCT_AREAS
  MANAGER_LOG_NO_ACCESS: 'manager_log_no_access',
  MANAGER_LOG_PAYWALL: 'manager_log_paywall',
  MESSAGE: 'message',
  MESSAGES: 'messages',
  MESSAGE_DRAWER: 'message_drawer',
  MISSED_PR_TEAM_PAID_FORM: 'missed_pr_team_paid_form',
  MISSED_PAYROLL_DEADLINE: 'missed_payroll_deadline',
  MISSED_PAYROLL_PAYDAY: 'missed_payroll_payday',
  MODAL_CALLBACK_FORM: 'modal_callback_form',
  MTC_TRIAL_PROMO_MODAL: 'mtc_trial_promo_modal',
  MULTILOCATION_CARD_UPDATE_REMINDER_MODAL:
    'multilocation_card_update_reminder_modal',
  MULTILOCATION_EOT_PAYWALLS_MODAL: 'multilocation_eot_paywalls_modal',
  MY_AVAILABILITY: 'my_availability',
  NAV: 'nav',
  NAVIGATION: 'navigation',
  NAV_PROFILE_DROPDOWN: 'nav_profile_dropdown',
  NBK_DOWNGRADE: 'nbk_downgrade',
  NBK_DOWNGRADE_NON_BIZ_HOURS: 'nbk_downgrade_non_biz_hours',
  NBK_DOWNGRADE_REQUEST_SUPPORT: 'nbk_downgrade_request_support',
  NBK_DOWNGRADE_REQUEST_SUPPORT_SUCCESS:
    'nbk_downgrade_request_support_success',
  NEEDS_REVIEW: 'needs_review',
  NEW_CONVERSATION: 'new_conversation',
  NEW_HIRE_ONBOARDING: 'new_hire_onboarding',
  NEW_LOCATION_MODAL: 'new_location_modal',
  ONBOARDING: 'onboarding',
  ON_TIME: 'on_time',
  OPEN_SHIFT_CARD: 'open_shift_card',
  OPTIONAL_BREAKS: 'optional_breaks',
  ORDER_SUMMARY_MODAL: 'order_summary_modal',
  OVERVIEW: 'overview',
  PAST_DUE_SUBSCRIPTIONS_BANNER: 'past_due_subscriptions_banner',
  PAST_DUE_SUBSCRIPTIONS_DIALOG: 'past_due_subscriptions_dialog',
  PAYING: 'paying',
  PAYING_BASE: 'paying_base',
  PAYROLL: 'payroll',
  PAYROLL_TAX_SETTINGS: 'payroll_tax_settings',
  PAYROLL_SUBMIT: 'payroll_submit',
  PAYROLL_CANCELLATION_DIALOG: 'payroll_cancellation_dialog',
  PAYROLL_COMPLETED: 'payroll_completed',
  PAYROLL_DASHBOARD: 'payroll_dashboard',
  PAYROLL_HELP_OTHER_CARD_L60: 'payroll_help_other_card_l60',
  PAYROLL_HELP_OTHER_CARD_M60: 'payroll_help_other_card_m60',
  PAYROLL_HISTORY_MODAL: 'payroll_history_modal',
  PAYROLL_TEAM_MEMBER_DRAWER: 'payroll_team_member_drawer',
  PAYROLL_DASHBOARD_STRUCTURED_SWITCHER_REMINDER_COMPONENT:
    'payroll_dashboard_structured_switcher_reminder_component',
  PAYROLL_DASHBOARD_W2_1099: 'dashboard_w2_1099',
  PAYROLL_IMPLEMENTATION_PROVIDER_ACCOUNT_ACCESS_COMPONENT:
    'payroll_implementation_provider_account_access_component',
  PAYROLL_NSF_PREDICTION_RESOLUTION: 'nsf_prediction_resolution',
  DASHBOARD_AUTOPAYROLL: 'dashboard_autopayroll',
  PAYROLL_RUN_WORKFLOW_SUBMISSION_MODAL_AUTOPAYROLL:
    'payroll_run_workflow_submission_confirmation',
  PAYROLL_RUN_WIDGET: 'payroll_run_widget',
  PAYROLL_RUN_WORKFLOW_HOURS_AND_TIME_OFF:
    'payroll_run_workflow_hours_and_time_off',
  PAYROLL_RUN_WORKFLOW_NET_PAY: 'payroll_run_workflow_net_pay',
  PAYROLL_RUN_WORKFLOW_REVIEW_AND_SUBMIT:
    'payroll_run_workflow_review_and_submit',
  PAYROLL_REPORTS: 'payroll_reports',
  PAYROLL_SETUP: 'payroll_setup',
  PAYROLL_SUMMARY: 'payroll_summary',
  PAYROLL_SUMMARY_DOWNLOAD_MODAL: 'payroll_summary_download_modal',
  PAYROLL_ACTION_NEEDED: 'homebase_payroll_action_needed',
  PAYROLL_READY_TO_RUN_BANNER: 'ready_to_run_banner',
  PAY_PERIOD_MENU: 'pay_period_menu',
  PAY_PERIOD_SETTINGS_MODAL: 'pay_period_settings_modal',
  POS_CONNECTION_SETTINGS_MODAL: 'pos_connection_settings_modal',
  POS_WEB_CONNECTION_DISCONNECT_YES: 'pos_web_connection_disconnect_yes',
  POST_PAYROLL_RUN_DETAILS: 'post_payroll_run_details',
  POST_TIMESHEETS_DOWNLOAD: 'post_timesheets_download',
  PROMOTION_HOMEBASE_DASHBOARD_BANNER_7_THANKSGIVING_2022_3_MONTHS_FREE:
    'promotion_homebase_dashboard_banner_7_thanksgiving_2022_3_months_free',
  PENDING_STATE_PAGE: 'pending_state_page',
  PTO_REQUESTS_WIDGET: 'pto_requests_widget',
  PURCHASE_FLOW: 'purchase_flow',
  QUICKBOOKS_TIMESHEETS_EXPORT: 'quickbooks_timesheets_export',
  QUICK_START_GUIDE_V2: 'quick_start_guide_v2',
  RECOMMENDATIONS: 'recommendations',
  REFERRALS: 'referrals',
  REPORT: 'report',
  REPORTS: 'reports',
  REQUEST_CALLBACK_MODAL: 'request_callback_modal',
  REQUEST_CALLBACK_SUCCESS_MODAL: 'request_callback_success_modal',
  REQUESTS_FEED: 'requests_feed',
  RETRIEVE_COMPANY_TIMESHEETS_DATE_RANGE:
    'retrieve_company_timesheets_date_range',
  REVIEW_AND_POST: 'review_and_post',
  ROSTER: 'roster',
  SCHEDULED_VS_ACTUAL_CLOCK_INS: 'scheduled_vs_actual_clock_ins',
  SCHEDULED_VS_ACTUAL_HOURS: 'scheduled_vs_actual_hours',
  SCHEDULE_BUILDER: 'schedule_builder',
  SCHEDULE_BUILDER_SYNC_SHIFTS: 'schedule_builder_sync_shifts',
  SCHEDULE_BUILDER_ADD_EVENT_MODAL: 'schedule_builder_add_event_modal',
  SCHEDULE_BUILDER_CLEAR_DEPARTMENT_SCHEDULE_MODAL:
    'schedule_builder_clear_department_schedule_modal',
  SCHEDULE_BUILDER_CLEAR_SCHEDULE_MODAL:
    'schedule_builder_clear_schedule_modal',
  SCHEDULE_BUILDER_CONFLICT_MODAL: 'schedule_builder_conflict_modal',
  SCHEDULE_BUILDER_DELETE_CONFIRMATION_MODAL:
    'schedule_builder_delete_confirmation_modal',
  SCHEDULE_BUILDER_EVENT_MODAL: 'schedule_builder_event_modal',
  SCHEDULE_BUILDER_EVENT_MODAL_COLLAPSE:
    'schedule_builder_event_modal_collapse',
  SCHEDULE_BUILDER_EVENT_MODAL_UNCOLLAPSE:
    'schedule_builder_event_modal_uncollapse',
  SCHEDULE_BUILDER_EVENT_DELETE_MODAL: 'schedule_builder_event_delete_modal',
  SCHEDULE_BUILDER_EXPANDED_FORECAST: 'schedule_builder_expanded_forecast',
  SCHEDULE_BUILDER_SHARE_FEEDBACK_MODAL:
    'schedule_builder_share_feedback_modal',
  SCHEDULE_BUILDER_JUMPSTART_DRAWER: 'schedule_builder_jumpstart_drawer',
  SCHEDULE_BUILDER_MANAGE_TEMPLATES_DRAWER:
    'schedule_builder_manage_templates_drawer',
  SCHEDULE_BUILDER_MANAGE_YOUR_EXPERIENCE:
    'schedule_builder_manage_your_experience_modal',
  SCHEDULE_BUILDER_PRINT_DRAWER: 'schedule_builder_print_drawer',
  SCHEDULE_BUILDER_PUBLISH_DRAWER: 'schedule_builder_publish_drawer',
  SCHEDULE_BUILDER_PUBLISH_HISTORY_MODAL:
    'schedule_builder_publish_history_modal',
  SCHEDULE_BUILDER_REPEAT_SCHEDULE_DRAWER:
    'schedule_builder_repeat_schedule_drawer',
  SCHEDULE_BUILDER_REVERT_SCHEDULE_MODAL:
    'schedule_builder_revert_schedule_modal',
  SCHEDULE_BUILDER_SHIFT_APPROVAL_MODAL:
    'schedule_builder_shift_approval_modal',
  SCHEDULE_BUILDER_SHIFT_MODAL: 'schedule_builder_shift_modal',
  SCHEDULE_BUILDER_TEMPLATE_DRAWER: 'schedule_builder_template_drawer',
  SCHEDULE_BUILDER_TIME_OFF_BLACKOUT_MODAL:
    'schedule_builder_time_off_blackout_modal',
  SCHEDULE_BUILDER_TIME_OFF_DELETE_MODAL:
    'schedule_builder_time_off_delete_modal',
  SCHEDULE_BUILDER_TIME_OFF_POPPER: 'schedule_builder_time_off_popper',
  SCHEDULE_BUILDER_TOOLS_DROPDOWN: 'schedule_builder_tools_dropdown',
  SCHEDULE_INSIGHTS: 'schedule_insights',
  SCHEDULE_INSIGHTS_EMPTY: 'schedule_insights_empty',
  SCHEDULING: 'scheduling',
  SCREENER_GENERATOR: 'screener_generator',
  SCREENER_INTERVIEW_REQUEST: 'screener_interview_request',
  SCREENER_NO_INTERVIEW: 'screener_no_interview',
  SECURITY: 'security',
  SETTINGS_EDIT_PASSWORD_MODAL: 'settings_edit_password_modal',
  SETTINGS_MFA_ENABLE_MODAL: 'settings_mfa_enable_modal',
  SETTINGS_MFA_DISABLE_MODAL: 'settings_mfa_disable_modal',
  SETTINGS_PAYROLL_AD: 'settings_payroll_ad',
  SHARE_POST: 'share_post',
  SIGN_UP: 'sign_up',
  SIGN_UP_FLOW: 'signup_flow',
  SHIFT_CARD_DETAILS: 'shift_card_details',
  SHIFT_COVER: 'shift_cover',
  SHIFT_FEEDBACK: 'shift_feedback',
  SHIFT_PAY_EMPLOYER_MARKETING: 'finserv_employer_info',
  SHIFT_TRADE: 'shift_trade',
  SHIFT_REASSIGNMENT: 'shift_reassignment',
  INITIATE_FIND_COVER_REQUEST: 'find_cover_initiate',
  SUBMIT_FIND_COVER_REQUEST: 'find_cover_submit',
  SHOPIFY_DOWNGRADE_BANNER: 'shopify_downgrade_banner',
  SIGNATURE_BLOCK: 'signature_block',
  SIGN_IN: 'sign_in',
  STATE_FORM: 'state_form',
  STEADY_STATE_PAGE: 'steady_state_page',
  SUB_MENU: 'sub_menu',
  SYNDICATION_PAGE: 'syndication_page',
  TEAM_ANNOUNCEMENTS_CARD: 'team_announcements_card',
  TEAM_AVAILABILITY: 'team_availability',
  TEAM_MESSENGER: 'team_messenger',
  TEAM_PAGE_HIRING_BANNER: 'team_page_hiring_banner',
  TEAM_PERMISSIONS: 'team_permissions',
  TEAM_REQUEST: 'team_request',
  TEAM_STATUS: 'team_status',
  TIERS_PAGE: 'tiers_page',
  TIMECARD_DETAIL: 'timecard_detail',
  TIMECARD_DETAILS: 'timecard_details',
  TIMECARDS_COMPLIANCE_UPSELL_MODAL: 'timecards_compliance_upsell_modal',
  TIMECLOCK_CHOICE_DRAWER_DISMISS: 'timeclock_choice_drawer_dismiss',
  TIME_OFF_CARD: 'time_off_card',
  TIMESHEETS_DAILY_REVIEW_EMPTY_STATE: 'timesheets_daily_review_empty_state',
  TIMESHEETS_PAY_PERIOD_REVIEW_EMPTY_STATE:
    'timesheets_pay_period_review_empty_state',
  TIMESHEETS_PAYROLL_SUMMARY_INDIVIDUAL:
    'timesheets_payroll_summary_individual',
  TIMESHEETS_SUB_TABLES: 'timesheets_sub_tables',
  TIMESHEETS_TABLE_HEADER: 'timesheets_table_header',
  TIMESHEETS_TOOLS: 'timesheets_tools',
  TIMESHEETS: 'timesheets',
  TIME_OFFS: 'time_offs',
  TIME_TRACKING: 'time_tracking',
  TIP_POOLING_TOOLTIP: 'tip_pooling_tooltip',
  TIPS_RECEIVED: 'tips_received',
  TIP_OUTS: 'tip_outs',
  TODAY_TAB: 'today_tab',
  TLWA_2025: 'tlwa_2025',
  TRADE_CARD: 'trade_card',
  TRIAL_INDICATOR: 'trial_indicator',
  UPCOMING: 'upcoming',
  WATCH_VIDEO_LINK_MODAL: 'watch_video_link_modal',
  WHITELISTING_PAGE: 'whitelisting_page',
  W_4_FORM: 'w_4_form',
  W_9_FORM: 'w_9_form',
  YOUR_ACCOUNT: 'your_account',
  ZERO_STATE_PAGE: 'zero_state_page',
  PREDICTIVE_SCHEDULING: 'predictive_scheduling',
  PREDICTIVE_SCHEDULING_SUCCESS: 'predictive_scheduling_success',
  PAYROLL_PAYMENT_FAILED_BANNER: 'payment_failed_banner',
  BILLING_CHANGE_PAYMENT_METHOD_MODAL: 'billing_change_payment_method_modal',
  CHANGE_BASE_WEEK: 'change_base_week',
  ANON_INTEGRATION: 'anon_integration',
  EOY_PAYROLL_BANNER: 'eoy_payroll_banner',
  PRE_IMPLEMENTATION: 'pre_implementation',
};

export const EVENT_ACTIONS = {
  TIMECARD_CLICKED: 'Timecard Clicked',
  ACCORDION_CLICKED: 'Accordion Clicked',
  ADD_AVAILABILITY_CLICKED: 'Add Availability Clicked',
  ADD_BREAK_CLICKED_V3: 'Add break clicked_v3',
  ADD_DOCUMENT_CLICKED: 'Add Document Clicked',
  ADD_EMPLOYEES_CLICKED: 'Add Employees Clicked',
  ADD_EMPLOYEE_SELECTED: 'Add Employee Selected',
  ADD_EVENT_CTA_CLICKED: 'Add Event CTA Clicked',
  ADD_EVENT_MODAL_CLOSED: 'Add Event Modal Closed',
  ADD_EVENT_MODAL_SHOWN: 'Add Event Modal Shown',
  ADD_EVENT_SELECTED: 'Add Event Selected',
  ADD_EVENT_SUCCESS_BANNER: 'Add Event Success Banner Shown',
  ADD_NEW_DEPARTMENT_CLICKED: 'Add New Department Clicked',
  ADD_HOURS_AND_BREAKS_AS_SCHEDULED_CLICKED:
    'Add hours and breaks as scheduled clicked',
  ADD_NEW_LOCATION_CLICKED: 'Add New Location Clicked',
  ADD_PAYROLL_PROVIDER_CLICKED: 'Add Payroll Provider Clicked',
  ADD_REASON_FOR_A_NO_SHOW_CLICKED_V3: 'Add a reason for a no-show clicked_v3',
  ADD_SHIFT_CLICKED: 'Add Shift Clicked',
  ADD_TEAM_DRAWER_SHOWN: 'Add Team Drawer Shown',
  ADD_TIME_OFF_BLACKOUT_CTA_CLICKED: 'Add Time Off Blackout CTA Clicked',
  ADD_TIME_OFF_SELECTED: 'Add Time Off Selected',
  ALERT_ICON_CLICKED: 'Alert Icon Clicked',
  ALERT_VIEWED: 'Alert Viewed',
  ALERTS_AND_PERMISSIONS_SHOWN: 'Alerts and Permissions Shown',
  ALL_ACCESS_PASS_CLICKED: 'All Access Pass Clicked',
  API_ACCESS_SHOWN: 'API Access Shown',
  APPLY_CTA_CLICKED: 'Apply CTA Clicked',
  APPLY_TEMPLATE_CLICKED: 'Apply Template Clicked',
  APP_STORE_CLICKED: 'App Store Clicked',
  AVAILABILITY_REQUEST_APPROVED: 'Availability Request Approved',
  AVAILABILITY_REQUEST_DECLINED: 'Availability Request Declined',
  BANNER_CLOSED: 'Banner Closed',
  BANNER_VIEWED: 'Banner Viewed',
  BANNER_SHOWN: 'Banner Shown',
  BASELINE_CLOSE_CLICKED: 'Baseline Close Clicked',
  BASELINE_DOWNLOAD_CLICKED: 'Baseline Download Clicked',
  BASELINE_SHOWN: 'Baseline Shown',
  BASIC_INFO_SHOWN: 'Basic Info Shown',
  SHARE_FEEDBACK_MODAL_SHOWN: 'Share Feedback Modal Shown',
  BOTTOM_DRAWER_VIEWED: 'Bottom Drawer Viewed',
  BREAK_AND_COMPLIANCE_SHOWN: 'Break and Compliance Shown',
  BREAK_DETAILS_EXPANDED_V3: 'Break details expanded_v3',
  BULK_ADD_ADD_EMPLOYEES_CLICKED: 'Bulk Add Add Employees Clicked',
  BULK_ADD_CHOICES_SHOWN: 'Bulk Add Choices Shown',
  BULK_ADD_CLICKED: 'Bulk Add Clicked',
  BULK_ADD_SPREADSHEET_SHOWN: 'Bulk Add Spreadsheet Shown',
  BULK_ADD_WAGES_SETTINGS_SHOWN: 'Bulk Add Wages Settings Shown',
  BULK_TERMINATE_CHOOSE_EMPLOYEES_SHOWN:
    'Bulk Terminate Choose Employees Shown',
  BUTTON_CLICKED: 'Button Clicked',
  CALENDAR_CLICKED: 'Calendar Clicked',
  CALL_CLICKED_V3: 'Call clicked_v3',
  CANCEL_SAVE_CLICKED: 'Cancel Save Clicked',
  CARD_CLICKED: 'Card Clicked',
  CARET_CLICKED: 'Caret Clicked',
  CHECK_ALL_IN_ONE_CLICKED: 'Check All-in-One clicked',
  CHECKBOX_CLICKED: 'Checkbox Clicked',
  CHECKBOX_SELECTED: 'Checkbox Selected',
  CHECKBOX_UNSELECTED: 'Checkbox Unselected',
  CHECK_OUT_PAYROLL_CLICKED: 'Check Out Payroll Clicked',
  CHECK_OUT_PAYROLL_SHOWN: 'Check Out Payroll Shown',
  CHIP_CLICKED: 'Chip Clicked',
  CLAIM_SHIFT_CLICKED: 'Claim Shift Clicked',
  CLEAR_CLICKED: 'Clear Clicked',
  CLICK_CTA: 'click_cta',
  CLICKED_SCHEDULE_DEMO: 'Clicked Schedule Demo',
  CLICKED_UPGRADE_DOCUMENTS: 'Clicked Upgrade Documents',
  CLICKED_UPGRADE_HR_PRO: 'Clicked Upgrade HR Pro',
  CLICKED_UPGRADE_NEW_HIRE_ONBOARDING: 'Clicked Upgrade New Hire Onboarding',
  CLOSE_CLICKED: 'Close Clicked',
  COMMON_SHIFT_CLICKED: 'Common Shift Clicked',
  COMPANY_DASHBOARD_SHOWN: 'Company Dashboard Shown',
  CONFLICTS_TOGGLE_BUTTON_CLICKED: 'Conflicts Toggle Button Clicked',
  CONFLICT_MODAL_CLOSED: 'Conflict Modal Closed',
  CONFLICT_MODAL_OPENED: 'Conflict Modal Opened',
  CONTINUE_CLICKED: 'Continue Clicked',
  CONTINUE_SETUP_CLICKED: 'Continue Setup Clicked',
  CONTINUE_SETUP_SHOWN: 'Continue Setup Shown',
  COPY_SHIFT_CLICKED: 'Copy Shift Clicked',
  CREATE_TEMPLATE_CLICKED: 'Create Template Clicked',
  CREDIT_CARD_VERIFIED: 'Credit Card Verified',
  CTA_CLICKED: 'cta_clicked',
  DATE_ARROW_CLICKED: 'Date Arrow Clicked',
  DATE_PERIOD_OPTION_CLICKED: 'Date Period Option Clicked',
  DATE_PICKER_CLICKED: 'Date Picker Clicked',
  DATE_SELECTION_CLICKED: 'Date Selection Clicked',
  DEBUG_CHECKOUT_STARTED: 'Debug Checkout Started', // DO NOT REUSE - FOR TEMPORARY DEBUGGING PURPOSES ONLY
  DEBUG_CHECKOUT_COMPLETED: 'Debug Checkout Completed', // DO NOT REUSE - FOR TEMPORARY DEBUGGING PURPOSES ONLY
  DELETE_CLICKED: 'Delete Clicked',
  DELETE_COMPANY_CLICKED: 'Delete Company Clicked',
  DELETE_CONFIRM_CLICKED: 'Delete Confirm Clicked',
  DELETE_CONFIRMATION_MODAL_SHOWN: 'Delete Confirmation Modal Shown',
  DELETE_DEPARTMENT_CLICKED: 'Delete Department Clicked',
  DELETE_SHIFT_CLICKED: 'Delete Shift Clicked',
  DELETE_TEMPLATE_CANCEL_CLICKED: 'Delete Template Cancel Clicked',
  DELETE_TEMPLATE_CLICKED: 'Delete Template Clicked',
  DELETE_TEMPLATE_CONFIRM_CLICKED: 'Delete Template Confirm Clicked',
  DELETE_TIMECARD_CLICKED_V3: 'Delete timecard clicked_v3',
  DELETE_TIMECARD_BREAK_CLICKED_V3: 'Delete timecard break clicked_v3',
  DISABLE_CLICKED: 'Disable Clicked',
  DISMISS_BREAK_CLICKED_V3: 'Dismiss break clicked_v3',
  DISMISS_CLICKED: 'Dismiss Clicked',
  DOCUMENTS_TAB_CLICKED: 'Documents Tab Clicked',
  DONE_CTA_CLICKED: 'Done CTA Clicked',
  DOWNGRADE_SCHEDULED: 'Downgrade Scheduled',
  DOWNLOAD_ALL_PAY_STATEMENTS_CLICKED: 'Download All Pay Statements Clicked',
  DOWNLOAD_CLICKED: 'Download Clicked',
  DOWNLOAD_FORMATTED_CLICKED: 'Download Formatted Clicked',
  DOWNLOAD_COMPANY_TIMESHEETS_SUMMARY_CLICKED:
    'Download Company Timesheets Summary Clicked',
  DOWNLOAD_COMPANY_TIMESHEETS_BY_LOCATION_CLICKED:
    'Download Company Timesheets By Location Clicked',
  DOWNLOAD_MESSAGE_LOG_CLICKED: 'Download Message Log Clicked',
  DRAWER_CLOSED: 'Drawer Closed',
  DOWN_CARET_CLICKED: 'Down Caret Clicked',
  UP_CARET_CLICKED: 'Up Caret Clicked',
  DRAWER_SHOWN: 'Drawer Shown',
  DROPDOWN_CLICKED: 'Dropdown Clicked',
  EDIT_CLICKED: 'Edit Clicked',
  EDIT_CLICKED_V3: 'Edit clicked_v3',
  EDIT_COLUMNS_CLICKED: 'Edit Columns Clicked',
  EDIT_DEPARTMENT_NAME_CLICKED: 'Edit Department Name Clicked',
  EDIT_HISTORY_CLICKED_V3: 'Edit history clicked_v3',
  EDIT_SHIFT_CLICKED: 'Edit Shift Clicked',
  EDIT_TEMPLATE_NAME_CHANGED: 'Edit Template Name Changed',
  EDIT_TEMPLATE_NAME_CLICKED: 'Edit Template Name Clicked',
  EMPLOYEE_SEARCH_CLICKED: 'Employee Search Clicked',
  EMPLOYEE_AVATAR_CLICKED: 'Employee Avatar Clicked',
  ENABLE_CLICKED: 'Enable Clicked',
  END_VIDEO: 'end_video',
  END_HIRING_VIDEO: 'end_hiring_video',
  ENFORCEMENT_DRAWER_REMOVE_TEAM_MEMBERS_CLICKED:
    'Enforcement Drawer Remove Team Members Clicked',
  GROWTH_MARKETING_DISCOUNT_COUPON_ATTACHED:
    'Growth Marketing Discount Coupon Attached',
  ENFORCEMENT_STAY_ON_PLAN_CLICKED: 'Enforcement Drawer Stay On Plan Clicked',
  ENTER_TAX_ID_CLICKED: 'Enter Tax ID clicked',
  ELEMENT_SHOWN: 'Element Shown',
  ERROR_MESSAGE_SHOWN: 'Error Message Shown',
  ERROR_PAGE_SHOWN: 'Error Page Shown',
  EVENTS_TRADES_SHOWN: 'Events and Trades Shown',
  EVENTS_QUOTA_LIMIT_REACHED: 'Events Quota Limit Reached',
  EXISTING_TEMPLATE_CLICKED: 'Existing Template Clicked',
  EXPORT_CLICKED: 'Export Clicked',
  EXPORT_COMPANY_TIMESHEETS_CLICKED: 'Export Company Timesheets Clicked',
  EXPORT_REPORT_CLICKED: 'Export Report Clicked',
  FAB_BUTTON_CLICKED: 'Fab Button Clicked',
  FIELD_FOCUSED: 'Field Focused',
  FINAL_PAGE_SHOWN: 'Final Page Shown',
  FIND_JOB_APPLICANTS_CLICKED: 'Find job applicants clicked',
  FIRST_RUN_PREVIEW_SHOWN: 'First Run Preview Shown',
  FORM_SHOWN: 'Form Shown',
  GET_A_TIME_CLOCK_SHOWN: 'Get a Time Clock Shown',
  GET_APP_CLICKED: 'Get App Clicked',
  GET_IT_LATER_CLICKED: 'Get It Later Clicked',
  GET_MOBILE_APP_CLICKED: 'Get Mobile App Clicked',
  GET_MOBILE_APP_MODAL_SHOWN: 'Get Mobile App Modal Shown',
  GET_MOBILE_APP_MODAL_SUBMITTED: 'Get Mobile App Modal Submitted',
  GET_STARTED_CLICKED: 'Get Started Clicked',
  HIRING_SURVEY_NEW_EMPLOYEE_ADDED: 'Hiring Survey New Employee Added',
  HISTORY_ITEM_COUNT_CLICKED: 'History Item Count Clicked',
  HOMEBASE_TAB_CLICKED: 'Homebase Tab Clicked',
  HOMEBASE_LOGO_CLICKED: 'Homebase Logo Clicked',
  ICON_CLICKED: 'Icon Clicked',
  ICON_BUTTON_CLICKED: 'Icon Button Clicked',
  INCEPTION_CLICKED: 'Inception Clicked',
  INVITE_MODAL_SHOWN: 'Invite Modal Shown',
  INITIAL_ACTIVATION: 'Initial Activation',
  ITEM_MOVED: 'Item Moved',
  JUMPSTART_PAST_WEEK_SUCCESS_BANNER_SHOWN:
    'Jumpstart - Past Week Success Banner Shown',
  JUMPSTART_TEMPLATE_SUCCESS_BANNER_SHOWN:
    'Jumpstart - Template Success Banner Shown',
  LABOR_TARGET_UPDATED: 'Labor Target Updated',
  LAUNCH_WEEK_AWARD_STARTED: 'Launch Week Award Started',
  LAUNCH_WEEK_AWARD_COMPLETED: 'Launch Week Award Completed',
  LAUNCH_WEEK_SHARE_STARTED: 'Launch Week Share Started',
  LINK_CLICKED: 'Link Clicked',
  LOCATION_CLICKED: 'Location Clicked',
  LOCATION_DROPDOWN_CLICKED: 'Location Dropdown Clicked',
  LOCATIONS_PINS_SHOWN: 'Locations and PINs Shown',
  MAKE_A_DIFFERENT_EDIT_CLICKED_V3: 'Make a different edit clicked_v3',
  MANAGER_VIEW_DASHBOARD_SHOWN: 'Manager View Dashboard Shown',
  MANAGE_PLAN_CLICKED: 'Manage Plan Clicked',
  MANAGE_TEMPLATES_DRAWER_CLOSED: 'Manage Templates Drawer Closed',
  MANAGE_TEMPLATES_DRAWER_OPENED: 'Manage Templates Drawer Opened',
  MANAGE_YOUR_EXPERIENCE_MODAL_SHOWN: 'Manage Your Experience Modal Shown',
  MANAGER_LOG_SHOWN: 'Manager Log Shown',
  MANUALLY_ADD_CLICKED: 'Manually Add Clicked',
  MESSAGE_CLICKED_V3: 'Message clicked_v3',
  MESSAGE_MY_TEAM_DRAWER_SHOWN: 'Message My Team Drawer Shown',
  MISSING_CONTACT_INFO_CLICKED: 'Missing Contact Info Clicked',
  MOBILE_TIME_CLOCK_TEXT_ME_LINK_CLICKED:
    'Mobile Time Clock Text Me Link Clicked',
  MODAL_SHOWN: 'Modal Shown',
  MODAL_VIEWED: 'Modal Viewed',
  MOVE_TO_OPEN_SHIFTS_CLICKED: 'Move To Open Shifts Clicked',
  MY_WEEK_DASHBOARD_SHOWN: 'My Week Dashboard Shown',
  NEW_CLICKED: 'New Clicked',
  NEW_LOCATION_ADDED: 'New Location Added',
  NOT_READY_TO_SIGN_UP_CLICKED: 'Not Ready to Sign Up Clicked',
  NOTES_HISTORY_CLICKED_V3: 'Notes history clicked_v3',
  NOTIFICATIONS_SHOWN: 'Notifications Shown',
  NOTIFY_MANAGER_CLICKED: 'Notify Manager Clicked',
  OPTIONS_MENU: 'Options Menu',
  ORDER_CHANGED: 'Order Changed',
  OTHER_INTERVAL_SELECTED: 'Other Interval Selected',
  OVERTIME_SHOWN: 'Overtime Shown',
  OWNER_SIGN_UP: 'Owner Sign Up',
  PAGE_VIEWED: 'Page Viewed',
  PARTNER_ADD_CLICKED: 'Partner Add Clicked',
  PARTNER_PAYROLL_IMPORT_CLICKED: 'Partner Payroll Import Clicked',
  PARTNER_POS_IMPORT_CLICKED: 'Partner POS Import Clicked',
  PANEL_CLOSED: 'Panel Closed',
  PANEL_OPENED: 'Panel Opened',
  PAUSE_VIDEO: 'pause_video',
  PAUSE_HIRING_VIDEO: 'pause_hiring_video',
  PAY_PERIOD_CLICKED: 'Pay Period Clicked',
  PAYROLL_SHOWN: 'Payroll Shown',
  PLAN_AND_BILLING_SHOWN: 'Plan and Billing Shown',
  PLAY_VIDEO: 'play_video',
  PLAY_HIRING_VIDEO: 'play_hiring_video',
  POS_CONNECTION_SHOWN: 'POS Connection Shown',
  POST_A_JOB_CLICKED: 'post_a_job_clicked',
  PRE_DETERMINED_INTERVAL_SELECTED: 'Pre-determined Interval Selected',
  PRINT_CLICKED: 'Print Clicked',
  PRINT_DRAWER_SHOWN: 'Print Drawer Shown',
  PRINT_OPTION_CLICKED: 'Print Option Clicked',
  PROFILE_CLICKED: 'Profile Clicked',
  PROFILE_SHOWN: 'Profile Shown',
  PUBLISH_BUTTON_CLICKED: 'Publish Button Clicked',
  PUBLISH_CLICKED: 'Publish Clicked',
  PUBLISH_HISTORY_MODAL_CLOSED: 'Publish History Modal Closed',
  PUBLISH_HISTORY_MODAL_SHOWN: 'Publish History Modal Shown',
  PUBLISH_HISTORY_SELECTED: 'Publish History Selected',
  PUBLISH_SCHEDULE_DRAWER_CLOSED: 'Publish Schedule Drawer Closed',
  PUBLISH_SCHEDULE_DRAWER_SHOWN: 'Publish Schedule Drawer Shown',
  PUBLISH_SUCCESS_DRAWER_CLOSED: 'Publish Success Drawer Closed',
  PUBLISH_SUCCESS_DRAWER_SHOWN: 'Publish Success Drawer Shown',
  RADIO_BUTTON_CLICKED: 'Radio Button Clicked',
  REATTEMPT_WITHDRAWAL_CLICKED: 'Re-attempt Withdrawal Clicked',
  RECOMMENDATION_CLICKED: 'Recommendation Clicked',
  REPEAT_INTERVAL_DROPDOWN_CLICKED: 'Repeat Interval Dropdown Clicked',
  REPEAT_INTERVAL_SELECTED: 'Repeat Interval Selected',
  REPEAT_SCHEDULE_CTA_CLICKED: 'Repeat Schedule CTA Clicked',
  REPEAT_SCHEDULE_DRAWER_CLOSED: 'Repeat Schedule Drawer Closed',
  REPEAT_SCHEDULE_DRAWER_SHOWN: 'Repeat Schedule Drawer Shown',
  REPEAT_SCHEDULE_SUCCESS_BANNER_SHOWN: 'Repeat Schedule Success Banner Shown',
  REQUEST_COVER_CLICKED: 'Request Cover Clicked',
  REQUEST_TIME_OFF_CLICKED: 'Request Time Off Clicked',
  RESOLVE_CLICKED: 'Resolve Clicked',
  RETRIEVE_COMPANY_TIMESHEETS_DATE_RANGE_CLICKED:
    'Retrieve Company Timesheets Date Range Clicked',
  RIGHT_PANEL_VIEWED: 'Right panel Viewed',
  SAVE_AND_ADD_ANOTHER_CLICKED: 'Save and Add Another Clicked',
  SAVE_AND_CLOSE_CLICKED: 'Save and Close Clicked',
  SAVE_AVAILABILITY_CLICKED: 'Save Availability Clicked',
  SAVE_EVENT_CTA_CLICKED: 'Save Event Clicked',
  SAVE_SHIFT_CLICKED: 'Save Shift Clicked',
  SAVE_WITH_CONFLICTS_CLICKED: 'Save With Conflicts Clicked',
  SCHEDULE_ENFORCEMENT_SHOWN: 'Schedule Enforcement Shown',
  SCHEDULE_PUBLISHED: 'Schedule Published',
  SCHEDULE_TAB_CLICKED: 'Schedule Tab Clicked',
  SCREEN_VIEWED: 'Screen Viewed',
  SECTION_VIEWED: 'Section Viewed',
  SEND_PACKET_CLICKED: 'Send Packet Clicked',
  SET_PASSWORD_CLICKED: 'Set Password Clicked',
  SET_PASSWORD_SHOWN: 'Set Password Shown',
  SETTINGS_CLICKED: 'Settings Clicked',
  SETTINGS_TAB_CLICKED: 'Settings Tab Clicked',
  SHIFT_APPROVAL_MODAL_SHOWN: 'Shift Approval Modal Shown',
  SHIFT_CHANGED: 'Shift Changed',
  SHIFT_COVER_REQUEST_APPROVED: 'Shift Cover Request Approved',
  SHIFT_COVER_REQUEST_DECLINED: 'Shift Cover Request Declined',
  SHIFT_MODAL_VIEWED: 'Shift Modal Viewed',
  SHIFT_NOTES_QUOTA_LIMIT_REACHED: 'Shift Notes Quota Limit Reached',
  SHIFT_PASTED: 'Shift Pasted',
  SHIFT_TRADE_REQUEST_APPROVED: 'Shift Trade Request Approved',
  SHIFT_TRADE_REQUEST_DECLINED: 'Shift Trade Request Declined',
  SHOWN: 'Shown',
  SIDE_DRAWER_VIEWED: 'Side Drawer Viewed',
  SIGNUP_1D1_CONVERSION: 'signup_1d1_conversion',
  SIGNUP_2D7_CONVERSION: 'signup_2d7_conversion',
  SIGNUP_2D30_CONVERSION: 'signup_2d30_conversion',
  SIGN_IN_SUCCESS: 'Sign In Success',
  SIGNATURE_CLICK: 'Signature Click',
  STEP_CLICKED: 'Step Clicked',
  SWITCH_CLICKED: 'Switch Clicked',
  SWITCHER_CLICKED: 'Switcher Clicked',
  SWITCHER_DROPDOWN_CLICKED: 'Switcher Dropdown Clicked',
  TAB_CLICKED: 'tab_clicked',
  TAB_SHOWN: 'tab_shown',
  TABLET_TIME_CLOCK_EMAIL_ME_LINK_CLICKED:
    'Tablet Time Clock Email Me Link Clicked',
  TEAM_MEMBER_CLICKED: 'Team Member Clicked',
  TEAM_MESSENGER_SHOWN: 'Team Messenger Shown',
  TEAM_PERMISSIONS_SHOWN: 'Team Permissions Shown',
  TEAM_TAB_CLICKED: 'Team Tab Clicked',
  TEMPLATES_SELECTED: 'Templates Selected',
  TIME_CLOCK_OPTIONS_SHOWN: 'Time Clock Options Shown',
  TIME_OFF_BLACKOUT_CLICKED: 'Time Off Blackout Clicked',
  TIME_OFF_BLACKOUT_MODAL_CLOSED: 'Time Off Blackout Modal Closed',
  TIME_OFF_BLACKOUT_MODAL_SHOWN: 'Time Off Blackout Modal Shown',
  TIME_OFF_CLICKED: 'Time Off Clicked',
  TIME_OFF_POPPER_SHOWN: 'Time Off Popper Shown',
  TIME_OFF_PTO_SHOWN: 'Time Off and PTO Shown',
  TIMECARD_NOTE_ADDED_V3: 'Timecard note added_v3',
  TIMESHEET_SUMMARY_PAYROLL_LINK_CLICKED:
    'Timesheet Summary Payroll Link Clicked',
  TIMESHEETS_TAB_CLICKED: 'Timesheets Tab Clicked',
  TIMESHEETS_TAB_SHOWN: 'Timesheets Tab Shown',
  TIP_POOLING_VIEWED: 'Tip pooling settings viewed',
  TIP_SETTINGS_VIEWED: 'Tip settings viewed',
  TODAY_BUTTON_CLICKED: 'Today Button Clicked',
  TOGGLE_CLICKED: 'Toggle Clicked',
  TOOLS_DROPDOWN_CLICKED: 'Tools Dropdown Clicked',
  TOOLTIP_VIEWED: 'Tooltip Viewed',
  TOOLTIP_DISMISSED: 'Tooltip Dismissed',
  TRADE_SHIFT_CLICKED: 'Trade Shift Clicked',
  UPGRADE_BUTTON_FROM_EDIT_HISTORY_V3: 'Upgrade button from Edit History_v3',
  UPGRADE_BUTTON_FROM_NOTES_PAYWALL_CLICKED_V3:
    'Upgrade button from Notes paywall clicked_v3',
  UPGRADE_BUTTON_FROM_PHOTO_GPS_PAYWALL_CLICKED_V3:
    'Upgrade button from Photo & GPS paywall clicked_v3',
  UPGRADE_SUCCESSFUL: 'Upgrade Successful',
  UPLOAD_PAPER_COPY_CLICKED: 'Upload Paper Copy Clicked',
  VALIDATION_ERROR_SHOW: 'Validation Error Shown',
  VIDEO_CLICKED: 'Video Clicked',
  VIEW: 'view',
  VIEW_ALL_TIMESHEETS_CLICKED: 'View All Timesheets Clicked',
  VIEW_DOCUMENT_CLICKED: 'View Document Clicked',
  VIEW_PAYROLL_CLICKED: 'View Payroll Clicked',
  VIEW_REQUESTS_CLICKED: 'View Requests Clicked',
  VIEWED: 'Viewed',
  WEB_TIME_CLOCK_LAUNCH_CLICKED: 'Web Time Clock Launch Clicked',
  WIRE_FUNDS_CLICKED: 'Wire Funds Clicked',
  ZERO_STATE_SHOWN: 'Zero State Shown',
  UPDATE_PAYMENT_BANNER_SHOWN: 'update_payment_banner_shown',
  UPDATE_PAYMENT_METHOD_CLICKED: 'update_payment_method_clicked',
  BILLING_MODAL_CLOSED: 'billing_modal_closed',
  BILLING_MODAL_SUBMIT: 'billing_modal_submit',
};

// Consult data team before adding any more track action types here
export const TRACK_ACTION_TYPES = {
  CLICK: 'click',
  VIEW: 'view',
  FOCUS: 'focus',
  BLUR: 'blur',
  HOVER: 'hover',
  DRAG: 'drag', // covers drag & drop as one action
};

export const PG_TRACK_EVENTS = {
  RETRIAL_ONBOARDING_REMINDER_MODAL: 'retrial_onboarding_reminder_modal',
  RETRIAL_ONBOARDING_ENROLLMENT: 'retrial_onboarding_enrollment',
  SHIFT_NOTE_DISCOVERABILITY: 'shift_note_discoverability',
  GEOFENCE_OVERLAY: 'geofence_overlay',
};

export const TRACK_EVENTS = {
  ADD_LOCATION: 'add_location',
  ZIP_RECRUITER: 'zip_recruiter',
  CS_CONTACT: 'cs_contact',
  TIMESHEETS_FOOTER_ALERT: 'timesheets_footer_alert',
  DASHBOARD_PRODUCT_USAGE_WIDGET: 'dashboard_product_usage_widget',
  MONETIZATION_UPSELL_ON_TIMESHEET_COMPLIANCE:
    'monetization_upsell_on_timesheet_compliance',
  HIRING_BOOST_POPUP: 'hiring_boost_popup',
  RETRIAL_ONBOARDING: 'retrial_onboarding',
};

export const TRACK_SOURCES = {
  BANNER: 'banner',
  MODAL: 'modal',
  SETTINGS: 'settings',
  DROPDOWN: 'dropdown',
  LOCATION_SUCCESS: 'location_success',
  DEPARTMENTS: 'departments',
  TAX_SETTINGS_ALERT: 'tax_settings_alert',
  PAYROLL_PRE_APPROVAL: 'payroll_pre_approval',
  PAYROLL_POST_APPROVAL: 'payroll_post_approval',
  TAX_SETUP_HELP: 'tax_setup_help_task',
};

export const TRACK_ACTIONS = {
  CLICKED: 'clicked',
  DISMISS: 'dismiss',
  SUCCESS: 'success',
  DEPARTMENT_SUCCESS: 'department_sucess',
  LOCATION_SUCCESS: 'location_sucess',
  CLICKED_CLOSED: 'clicked_closed',
  CLICKED_CTA: 'clicked_cta',
  CLICKED_LEARN_MORE: 'clicked_learn_more',
  VIEW: 'view',
  VIEWED_HIRING_DASHBOARD: 'viewed_hiring_dashboard',
  VIEWED_PAGE: 'viewed_page',
  VIEWED_UPSELL: 'viewed_upsell',
  VIEWED: 'viewed',
  CLICKED_ADD_LOCATION: 'clicked_add_location',
  CHAT: 'chat',
  ADD: 'add',
  WORKSITE: 'worksite',
  LOCATION: 'location',
  CLICKED_BACK: 'clicked_back',
  VIEW_MODAL: 'view_modal',
  SSO_CARD_CLICKED: 'sso_card_clicked',
  CLOSED: 'closed',
  CLICKED_CONTINUE_SYNDICATION_PAGE: 'Clicks Continue',
  VIEWED_SYNDICATION_PAGE: 'Viewed Syndication Page',
  CLICKED_OPTION_SYNDICATION_PAGE: 'Select/Deselects Syndication Options',
  VIEWED_APPLICATION_QUESTIONS_PAGE: 'Viewed',
  CLICKED_ADD_APPLICATION_QUESTIONS_PAGE: 'Clicked Add',
  CLICKED_REMOVE_APPLICATION_QUESTIONS_PAGE: 'Clicked Remove',
  CLICKED_SKIP_APPLICATION_QUESTIONS_PAGE: 'Clicked Skip',
  CLICKED_SUBMIT_APPLICATION_QUESTIONS_PAGE: 'Clicked Submit',
  CLICKED_CANCEL: 'Clicked Cancel',
  CLICKED_SETTINGS: 'Clicked Settings',
  CLICKED_ADD_TIME_OFF: 'Clicked Add Time Off',
  CLICKED_APPROVE_TIME_OFF: 'Clicked Approve Time Off',
  CLICKED_DECLINE_TIME_OFF: 'Clicked Decline Time Off',
  CLICKED_CREATE_PTO_POLICY: 'Clicked Create Policy',
  CLICKED_EDIT_PTO_POLICY: 'Clicked Edit Policy',
  CLICKED_DELETE_PTO_POLICY: 'Clicked Delete Policy',
};

export const TRACK_PROPERTIES = {
  HIRING_GET_MORE_APPLICANTS: 'get_more_applicants',
  DELETE: 'delete',
  EVENT: 'event',
  SHIFT: 'shift',
  PAYROLL_BANNER_DISMISSED: 'Payroll Banner Dismissed',
  PAYROLL_BANNER_REMIND_ME_TOMORROW: 'Payroll Banner Remind me tomorrow',
  PAYROLL_BANNER_GO_TO_PAYROLL: 'Go to Payroll',
  PAYROLL_BANNER_ADD_TO_CALENDAR: 'Payroll_add_to_calendar',
  PAYROLL_BANNER_ADD_TO_ICAL: 'Payroll_add_to_calendar_ical',
  PAYROLL_BANNER_ADD_TO_GOOGLE: 'Payroll_add_to_calendar_google',
  PAYROLL_BANNER_ADD_TO_OUTLOOK: 'Payroll_add_to_calendar_outlook',
};

export const TRACK_CATEGORY = {
  PAYING: 'paying',
  NON_PAYING: 'non-paying',
  NONE: 'none',
  CLOCKED_IN: 'clocked in',
  CLOCKED_OUT: 'clocked out',
  CLOCKED_IN_BREAK: 'clocked in break',
  CLOCKED_OUT_BREAK: 'clocked out break',
};

export const TRACK_STARTING_PATHS = {
  DASHBOARD: 'dashboard',
  DASHBOARD_V1: 'dashboard v1',
  DASHBOARD_V3: 'dashboard v3',
  TIMESHEETS: 'timesheets',
  ALERTS: 'alerts',
  TEAM: 'team',
  TEAM_AVAILABILITY: 'team availability',
  SCHEDULE: 'schedule',
  VIEW_APPLICANTS: 'view applicants',
  DOCUMENTS: 'documents',
  TIME_OFFS: 'time off',
};

export const URL_STARTING_PATHS = {
  '/team': TRACK_STARTING_PATHS.TEAM,
  '/availabilities': TRACK_STARTING_PATHS.TEAM_AVAILABILITY,
  '/schedule': TRACK_STARTING_PATHS.SCHEDULE,
  '/hiring/job_requests/:id/manage_applicants':
    TRACK_STARTING_PATHS.VIEW_APPLICANTS,
  '/documents': TRACK_STARTING_PATHS.DOCUMENTS,
  '/dashboard/location': TRACK_STARTING_PATHS.DASHBOARD,
};

export const LINKED_IN_EVENT_IDS = {
  owner_signup: 6144114,
};

export const ELEMENTS = {
  ADD_NOTES_BUTTON: 'add_notes_button',
  BOOST_MODAL: 'boost_modal',
  BOOST_NOW_BUTTON: 'boost_now_button',
  CANCEL_BUTTON: 'cancel_button',
  CASHOUT_JOB_DESCRIPTION_CHECKBOX: 'cashout_job_description_checkbox',
  CREATE_YOUR_OWN_CARD: 'create_your_own_card',
  DECLINE_BUTTON: 'decline_button',
  DECLINE_FIRST_TIME_INFORMATIONAL: 'decline_first_time_informational',
  DECLINE_REASON_BUTTON: 'decline_reason_button',
  DECLINE_REASON_MODAL: 'decline_reason_modal',
  DISCOVER_NOW_BUTTON: 'discover_now_button',
  DONT_SHOW_AGAIN_BUTTON: 'dont_show_again_button',
  ENTER_NEW_CREDIT_CARD_LINK: 'enter_new_credit_card_link',
  GET_MORE_APPLICANTS_BUTTON: 'get_more_applicants_button',
  GOT_IT_BUTTON: 'got_it_button',
  HIRING_DASHBOARD_LINK: 'hiring_dashboard_link',
  HOMEBASE_JOB_BOARD_LINK: 'homebase_job_board_link',
  INTERVIEW_BUTTON: 'interview_button',
  INTERVIEW_DATE_TIME: 'interview_date_time',
  INTERVIEW_FIRST_TIME_INFORMATIONAL: 'interview_first_time_informational',
  INTERVIEW_SCHEDULING_TYPE: 'interview_scheduling_type',
  JOB_ALERTS_LOCATION_OPTIN: 'job_alerts_location_optin',
  JOB_ALERTS_ROLE_OPTIN: 'job_alerts_role_optin',
  JOB_CARD_TITLE: 'job_card_title',
  LAUNCH_WEEK_VIEW_AWARD: 'view_award',
  LAUNCH_WEEK_UNLOCK_AWARD: 'unlock_award',
  LAUNCH_WEEK_DO_IT_LATER: 'do_it_later',
  LAUNCH_WEEK_STEP_LABELS: {
    OAM_NAME: 'oam_name',
    AMAZING_WORKPLACE: 'amazing_workplace',
    STOOD_OUT: 'stood_out',
    HIGHLIGHTS: 'highlights',
    SERVE_COMMUNITY: 'serve_community',
    HOURS_OF_WORK: 'hours_of_work',
    NUMBER_OF_SHIFTS: 'number_of_shifts',
    MADE_WORK_FUN: 'made_work_fun',
    NUMBER_OF_MESSAGES: 'number_of_messages',
    WORK_FLEXIBLE: 'work_flexible',
    HOW_YOU_DO_IT: 'how_you_do_it',
    TOP_LOCAL_WORKPLACE: 'top_local_workplace',
    HOLD_ON: 'hold_on',
    JOHN_VIDEO: 'john_video',
  },
  LAUNCH_WEEK_SHARE_YOUR_AWARD: 'share_your_award',
  LEARN_MORE_LINK: 'learn_more_link',
  MAYBE_LATER_BUTTON: 'maybe_later_button',
  NEXT_BUTTON: 'next_button',
  OLD_PREMIUM_BOOST_NOT_AVAILABLE_MODAL:
    'old_premium_boost_not_available_modal',
  PREMIUM_BOOST_NOT_AVAILABLE_MODAL: 'premium_boost_not_available_modal',
  REACTIVATE_BUTTON: 'reactivate_button',
  REQUEST_ADD_APPLICANT_BUTTON: 'request_add_applicant_button',
  ROLE_CARD: 'role_card',
  SCHEDULE_INTERVIEW_BUTTON: 'schedule_interview_button',
  STATUS_DROPDOWN: 'status_dropdown',
  SUBMIT_BUTTON: 'submit_button',
  THUMBS_DOWN_BUTTON: 'thumbs_down_button',
  THUMBS_UP_BUTTON: 'thumbs_up_button',
  UNPASS_THUMBS_DOWN_BUTTON: 'unpass_thumbs_down_button',
  WEB_TO_APP_CTA: 'web_to_app_cta',
  WHATS_NEW_BUTTON: 'whats_new_button',
};

export const PARTNERS = {
  BOOST_CRAIGSLIST: 'boost_craigslist',
  BOOST_ZIP_RECRUITER: 'boost_ziprecruiter',
};

export const MODAL_TYPES = {
  EXIT_CONFIRMATION: 'exit_confirmation',
};
